import { render, staticRenderFns } from "./Industriefotografie.vue?vue&type=template&id=0b63b977&scoped=true&"
import script from "./Industriefotografie.vue?vue&type=script&lang=js&"
export * from "./Industriefotografie.vue?vue&type=script&lang=js&"
import style0 from "./Industriefotografie.vue?vue&type=style&index=0&id=0b63b977&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63b977",
  null
  
)

export default component.exports